{
  "version": 1,
  "ai_win_pct": 71
}
